module.exports = __webpack_public_path__ + "static/media/mysql.2b3975f8.png";